var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ImageSelectCropper',{attrs:{"id-image":_vm.idImage,"context":"community","width":396,"height":223},on:{"changeImage":_vm.onChangeImage,"removeImage":_vm.onRemoveImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }